export default "__VITE_ASSET__Bk6bbkhl__"